import { FlashNoticeVariant } from 'components/FlashNotice'
import { showFlashNotice } from 'components/FlashNotice/duck/actions'

import { ScoutingCampaign } from '../../../../../../../../entities-next/scoutingCampaign'

export function successfulScoutingCampaignUpdateAction(corporate: Pick<ScoutingCampaign, 'name'>) {
  return showFlashNotice({
    message: `Space "${corporate.name}" successfully updated!`,
    autoHide: true,
    variant: FlashNoticeVariant.success,
  })
}

export function successfulScoutingCampaignCreationAction(corporate: Pick<ScoutingCampaign, 'name'>) {
  return showFlashNotice({
    message: `Space "${corporate.name}" successfully created!`,
    autoHide: true,
    variant: FlashNoticeVariant.success,
  })
}

export function failedScoutingCampaignOperationAction(e: Error) {
  return showFlashNotice({
    message: `Unexpected error occurred, please contact an administrator: ${e.message}`,
    autoHide: false,
    variant: FlashNoticeVariant.error,
  })
}
